import { render, staticRenderFns } from "./MtsTakipHazirlaBetaView.vue?vue&type=template&id=7a8a4b3c"
import script from "./MtsTakipHazirlaBetaView.vue?vue&type=script&lang=ts"
export * from "./MtsTakipHazirlaBetaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports